export default "__VITE_ASSET__4Mi8VWYx__"